import { useAbility } from '@casl/react';
import React from 'react';
import { AbilityContext } from '../../context/Ability';
import { Navigate } from 'react-router-dom';

const CustomNavigate = ({ to, redirect, action, module }) => {
  const ability = useAbility(AbilityContext);
  return ability.can(action, module) ? <Navigate to={to} /> : <Navigate to={redirect} />;
};

export default CustomNavigate;
